/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import { SubmitButton, TextAreaField, TextField } from 'components/form'
import { ProcedimentoOdontoSelectField } from 'components/form/field/select/ProcedimentoOdontoSelectField'
import { TipoParteBucalEnum } from 'graphql/types.generated'
import { Fragment } from 'react'
import { Form, FormRenderProps } from 'react-final-form'
import { metaPath } from 'util/metaPath'

import { dentesSupranumeriosFormValidator } from './AdicionarDenteSupranumerarioPopup'
import { EvolucaoDenteSupranumerarioModel, trimSupranumeriosObservacao } from './DentesSupranumerariosField'

export interface EditarDentesSupranumerariosModalProps {
  isOpen?: boolean
  cidadaoDataNascimento: LocalDate
  initialValues?: EvolucaoDenteSupranumerarioModel
  onSubmit(values: EvolucaoDenteSupranumerarioModel): void
  onCancel(): void
}

const path = metaPath<EvolucaoDenteSupranumerarioModel>()

export const EditarDentesSupranumerariosModal = (props: EditarDentesSupranumerariosModalProps) => {
  const { isOpen, cidadaoDataNascimento, initialValues, onSubmit, onCancel } = props

  return (
    <Fragment>
      <Modal size='small' onClose={onCancel} open={isOpen}>
        <Form<EvolucaoDenteSupranumerarioModel>
          initialValues={initialValues}
          validate={dentesSupranumeriosFormValidator}
          onSubmit={(values) => onSubmit(trimSupranumeriosObservacao(values))}
          render={(formProps: FormRenderProps<EvolucaoDenteSupranumerarioModel>) => (
            <Fragment>
              <ModalBody>
                <VFlow>
                  <VFlow vSpacing={0}>
                    <Heading level={1}>Edição de dentes supranumerários</Heading>
                    <Text>{initialValues.local}</Text>
                  </VFlow>

                  <TextField name={path.local} label='Local' maxLength={200} required />

                  <ProcedimentoOdontoSelectField
                    name={path.procedimentos}
                    label='Procedimentos (Evolução odontológica)'
                    multiple
                    dataNascimento={cidadaoDataNascimento}
                    tipoParteBucal={TipoParteBucalEnum.SUPRANUMERARIO}
                    required
                  />

                  <TextAreaField
                    name={path.observacao}
                    label='Observações'
                    maxLength={400}
                    style={{ resize: 'none' }}
                  />
                </VFlow>
              </ModalBody>

              <ModalFooter>
                <HFlow justifyContent='flex-end'>
                  <Button
                    style={css`
                      width: 9.75rem;
                    `}
                    onClick={onCancel}
                  >
                    Cancelar
                  </Button>

                  <SubmitButton
                    style={css`
                      width: 9.75rem;
                    `}
                    title='Salvar'
                    kind='primary'
                    handleSubmit={formProps.handleSubmit}
                  >
                    Salvar
                  </SubmitButton>
                </HFlow>
              </ModalFooter>
            </Fragment>
          )}
        />
      </Modal>
    </Fragment>
  )
}
